import type { CampaignPublicView } from '@/server/initState/getCampaignConfig';

export const SET_CAMPAIGN_CONFIG = 'SET_CAMPAIGN_CONFIG';

// Extends the wire shape with the route's own slug (not part of the API response) and
// the query params the landing route ingests alongside it (offer_code/code + UTM), so
// they survive SSR into client state without a second store slice.
export type CampaignConfig = CampaignPublicView & {
	slug: string;
	offer_code?: string;
	// True only once CampaignCodeEntry has confirmed offer_code via postValidateCampaignCode
	// (or, for a codeless campaign, decided there's nothing to validate). offer_code alone
	// can't stand in for "validated": [slug].tsx seeds it straight from the URL, before any
	// validation runs, so a routing decision that only checked offer_code's truthiness could
	// send a not-yet-validated code straight to Payment.
	codeValidated?: boolean;
	utm_source?: string;
	utm_medium?: string;
	utm_campaign?: string;
	utm_content?: string;
	utm_term?: string;
};
